export default [
  {
    path: '/v3/home',
    name: 'home',
    component: () => import('@/modules/home/views/pages/Home.vue'),
    meta: {
      title: 'Home',
      requiredUserPermissions: ['home'],
      allowOnlyMercapromo: true,
    },
  },
]
